<mat-toolbar color="primary" class="expanded-toolbar">
  <span>
    <button mat-button routerLink="/">{{title}}</button>
    <!-- <button mat-button routerLink="/"><mat-icon>home</mat-icon></button> -->
  </span>
  <!-- <div fxLayout="row" fxShow="false" fxShow.gt-sm>
      <form [formGroup]="searchForm" (ngSubmit)="onSearch()">
        <div class="input-group">
          <input class="input-group-field" type="search" value="" placeholder="Search" formControlName="search">
          <div class="input-group-button"><button mat-flat-button color="accent"><mat-icon>search</mat-icon></button></div>
        </div>
      </form>
  </div> -->
  <button mat-button [mat-menu-trigger-for]="menu" fxHide="false" fxHide.gt-sm>
    <mat-icon>menu</mat-icon>
  </button>
</mat-toolbar>
<mat-menu x-position="before" #menu="matMenu">
  <button mat-menu-item routerLink="/"><mat-icon>home</mat-icon> خانه</button>
  <button mat-menu-item routerLink="/news"><mat-icon>history_edu</mat-icon> اخبار</button>
  <button mat-menu-item routerLink="/contactus"><mat-icon>contact_mail</mat-icon> تماس با ما</button>
  <button mat-menu-item routerLink="/aboutus"><mat-icon>home_work</mat-icon> درباره ما</button>
  <!-- <form [formGroup]="searchForm" (ngSubmit)="onSearch()">
    <div class="input-group">
      <input class="input-group-field" type="search" value="" placeholder="Search" formControlName="search">
      <div class="input-group-button"><button mat-button routerLink="/"><mat-icon>magnify</mat-icon></button></div>
    </div>
  </form> -->
</mat-menu>
<div style="text-align: center;" class="col-lg-3 col-md-2 col-md-none  col-sm-none"></div>
<div style="text-align: center;" class="col-lg-6 col-md-8 col-md-12 col-sm-12">
  <router-outlet></router-outlet>
  <div style="text-align: center;">
    <ins data-revive-zoneid="3" data-revive-id="b693742677202eaf8c8eadc1ececa7e8"></ins>

  </div>
  <div class="footer">
    <ins data-revive-zoneid="4" data-revive-id="b693742677202eaf8c8eadc1ececa7e8"></ins>

    <div style="direction:rt1">
      طراحی و پشتیبانی با 
      <a href="http://ntk.ir"> نگین تجارت کاروی

      </a>

      <a href="https://karavi.ca">

        Karavi Developer

      </a>
    </div>
  </div>
</div>
<div style="text-align: center;" class="col-lg-3 col-md-2 col-md-none col-sm-none"></div>